import { Component, AfterViewInit, Input } from '@angular/core';
import { LoaderEnabled } from '../../../../../../shared/components/loader/loader.service';
import { Observable } from 'rxjs/Observable';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { CoreServiceRegistry } from '../../../../../../core/core-service-registry';
import { SharedServiceRegistry } from '../../../../../../shared/shared-service-registry';

@Component({
  selector: 'lfwms-asn-sku-image-acc-content',
  templateUrl: './asn-sku-image-acc-content.component.html',
  styleUrls: ['./asn-sku-image-acc-content.component.css']
})
export class AsnSkuImageAccContentComponent implements AfterViewInit {

  public imgUrlArray: Array<any> = [];
  public index: number = 0;
  public currentImgUrl: string = '';
  public showImgViewer: boolean = false;
  public http$: HttpClient;
  public storerKey: string = '';
  public receiptKey: string = '';
  public alertService: any;
  public resourceService: any;
  public confirmDialogService: any;
  @Input()
  public asnCellDataMap: any;

  ngAfterViewInit() {
    this.storerKey = this.asnCellDataMap['storerKey'].cVal;
    this.receiptKey = this.asnCellDataMap['receiptKey'].cVal;
    const pOKey: string = this.asnCellDataMap['poKey'].cVal;
    const externPOKey: string = '';

    this.getImageUrl(this.storerKey, this.receiptKey, pOKey, externPOKey).subscribe((response) => {
       this.imgUrlArray = response['results'] ? response['results'] : [];
    });
  }

  constructor(
    protected coreServiceRegistry: CoreServiceRegistry,
    protected sharedServiceRegistry: SharedServiceRegistry
  ) {
    this.http$ = coreServiceRegistry.http$;
    this.alertService = sharedServiceRegistry.alertService;
    this.resourceService = coreServiceRegistry.resourceService;
    this.confirmDialogService = sharedServiceRegistry.confirmDialogService;
  }

    public openImgInFullView(index: number) {
      this.currentImgUrl = this.imgUrlArray[index]['ImageURL'];
      this.index = index;
      this.showImgViewer = this.currentImgUrl ? true : false;
    }

    /**
     * navigate To Next Or Previous Image
     */
    public navigateToNextOrPreviousImage(nextOrPrevious: string) {
        this.index = nextOrPrevious === 'next' ?  this.index + 1 : this.index - 1;
        this.currentImgUrl = this.imgUrlArray[this.index]['ImageURL'];
    }


    @LoaderEnabled()
    public getImageUrl(storerKey: string, receiptKey: string, pOKey: string,  externPOKey: string ): Observable<any> {
      const request = {
                        'storerKey': storerKey,
                        'receiptKey': receiptKey,
                        'externReceiptKey': '',
                        'pOKey': pOKey,
                        'externPOKey': externPOKey,
                        'docRef01': '',
                        'docRef02': '',
                        'docRef03': ''
                    };

        const response$ = this.http$.post(`api/asn/image/url/`, JSON.stringify(request))
        .map((response: any) => {
          return response;
        })
        .catch((error: any) => {
          if (error.error.length !== 0) {
            if (error.error.statusCode !== 200) {
              return Observable.throw(error.error.statusMessage);
            }
          }
        });
      return response$;
    }

    /**
     * Download image at the given index
     */
    public downloadImage(index: number) {
      const imageData = this.imgUrlArray[index];
      const filename = this.extractFilename(imageData.ImageURL);

      this.http$.get(`api/image/ASN/${this.storerKey}/${this.receiptKey}/?filename=${filename}`, {
        responseType: 'blob'
      }).subscribe(
        (blob: Blob) => {
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.download = filename;
          link.click();
          window.URL.revokeObjectURL(url);
        },
        (error) => {
          this.alertService.clearAll().error(this.resourceService.get('msg_download_failed'));
        }
      );
    }

    /**
     * Delete image at the given index - shows confirmation first
     */
    public deleteImage(index: number) {
      this.confirmDialogService.confirmDialog([
        this.resourceService.get('msg_delete_asn_image')
      ]).subscribe((confirmed: boolean) => {
        if (confirmed) {
          this.performDeleteImage(index);
        }
      });
    }

    /**
     * Perform the actual delete API call
     */
    private performDeleteImage(index: number) {
      const imageData = this.imgUrlArray[index];
      const filename = this.extractFilename(imageData.ImageURL);

      this.http$.delete(`api/image/ASN/${this.storerKey}/${this.receiptKey}/?filename=${filename}`)
        .subscribe(
          (response: any) => {
            this.imgUrlArray.splice(index, 1);
            this.alertService.clearAll().success(this.resourceService.get('msg_delete_success'));
            this.showImgViewer = false;
          },
          (error) => {
            this.alertService.clearAll().error(this.resourceService.get('msg_delete_failed'));
          }
        );
    }

    /**
     * Extract filename from image URL
     */
    private extractFilename(imageUrl: string): string {
      const parts = imageUrl.split('/');
      return parts[parts.length - 1].split('?')[0];
    }

}



// WEBPACK FOOTER //
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/app/features/inbound/asn/asn-home/asn-details/asn-sku-image-acc-content/asn-sku-image-acc-content.component.ts